export default __webpack_public_path__ + "static/media/list-calendar.36a27580.png";